import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  accountList: {
    maxHeight: '210px',
    overflowY: 'auto',
  },
  customBackdrop: {
    zIndex: '1000000 !important',
  },
  deleteAccountsConfirmDialog: {
    zIndex: '1000001 !important',
  },
  customSizeModal: {
    width: 547,
    maxWidth: 547,
  },
});
